import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BookedSessionByBookingKey, BookingUser } from 'app/shared/models/class/booking-session/booking-session';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingSessionService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getBookingByUser(userKey: string): Observable<BookingUser[]> {
    return this.http.get<BookingUser[]>(`${environment.apiUrl}/BookingSession/Booking/${userKey}`);
  }

  getBookingByClub(clubCode: string): Observable<BookingUser[]> {
    return this.http.get<BookingUser[]>(`${environment.apiUrl}/BookingSession/BookingClub/${clubCode}`);
  }

  getSessionsByBooking(bookingKey: number): Observable<BookedSessionByBookingKey[]> {
    return this.http.get<BookedSessionByBookingKey[]>(`${environment.apiUrl}/BookingSession/BookingSession/${bookingKey}`);
  }

  getBookingByUserAndByClub(userKey: number, clubCode: string): Observable<BookingUser[]> {
    return this.http.get<BookingUser[]>(`${environment.apiUrl}/BookingSession/BookingUserClub/${userKey}/${clubCode}`);
  }


}
